import * as Yup from "yup";
import { REGEX_ONLY_NUMBER_AND_HYPHEN } from "../../../helpers/constants";
import {
  specialCharactersNotAllowedValidationForOptionalField,
  validEmailValidation,
  validFieldValidation,
} from "../../../helpers/constants/commonValidationSchemaUtils";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import {
  AGEING_FILTER_KEYS,
  ParticipantsSearchFormKey,
  SEARCH_TYPE_KEY,
} from "./Models";

export const SearchParticipantSchema = (
  commonValidationMessages: KeyValueMap,
) =>
  Yup.object().shape({
    [ParticipantsSearchFormKey.resetForm]: Yup.boolean().default(false),
    [ParticipantsSearchFormKey.searchType]: Yup.string().default(
      SEARCH_TYPE_KEY.myCaseLoads,
    ),
    [ParticipantsSearchFormKey.participantFirstName]:
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      ),
    [ParticipantsSearchFormKey.participantFirstNameFilter]: Yup.string(),
    [ParticipantsSearchFormKey.participantLastName]:
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      ),
    [ParticipantsSearchFormKey.participantLastNameFilter]: Yup.string(),
    [ParticipantsSearchFormKey.keyNumber]: validFieldValidation(
      commonValidationMessages.alphabetOrSpecialCharNotAllowed,
      REGEX_ONLY_NUMBER_AND_HYPHEN,
    ),
    [ParticipantsSearchFormKey.keyNumberFilter]: Yup.string(),
    [ParticipantsSearchFormKey.participantEmail]: validEmailValidation(
      commonValidationMessages.invalidEmail,
    ).default(""),
    [ParticipantsSearchFormKey.participantEmailFilter]: Yup.string(),
    [ParticipantsSearchFormKey.mobileISOCode]: Yup.string(),
    [ParticipantsSearchFormKey.mobileCountryCode]: Yup.string(),
    [ParticipantsSearchFormKey.participantMobileNumber]: Yup.string(),
    [ParticipantsSearchFormKey.clientName]:
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      ),
    [ParticipantsSearchFormKey.clientNameFilter]: Yup.string(),
    [ParticipantsSearchFormKey.ageing]: Yup.string().default(
      AGEING_FILTER_KEYS.ALL,
    ),
    [ParticipantsSearchFormKey.coachIds]: Yup.array().default([]),
    [ParticipantsSearchFormKey.coachType]: Yup.string(),
    [ParticipantsSearchFormKey.participantStatus]: Yup.array().default([]),
  });
